import { Component, OnInit, HostListener, ViewChild, Input, ElementRef, Output, EventEmitter, ContentChildren, QueryList, AfterViewInit, ContentChild } from '@angular/core';
import { ThemeService } from '../theme.service';
import { BaseComponent } from '../classes/BaseComponent';

@Component({
  selector: 'app-filter-dropdown',
  templateUrl: './filter-dropdown.component.html',
  styleUrls: ['./filter-dropdown.component.scss']
})
export class FilterDropdownComponent extends BaseComponent implements OnInit {

  @Input() title = "";
  @Input() label = "";
  @Input() right: boolean = false;
  @Input() redText: boolean = false;
  @Input() selection: string = "";
  @Output() onReset = new EventEmitter();
  @Output() onOpen = new EventEmitter();
  @Input() alignLeft: boolean = false;

  public elementRef;
  @ViewChild('dropdownContent', {static: false}) dropdownContent;

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!event || !event.target) {
      return;
    }
    try {
      if (this.elementRef && this.elementRef.nativeElement && !this.elementRef.nativeElement.contains(event.target)) {
        // Safely check className - handle cross-origin iframe elements
        let classNameString = '';
        try {
          const className = event.target.className;
          if (className) {
            if (typeof className === 'string') {
              classNameString = className;
            } else if (className && typeof className === 'object') {
              if (className.baseVal !== undefined) {
                classNameString = className.baseVal || '';
              } else if (typeof className.toString === 'function') {
                classNameString = className.toString();
              }
            }
          }
        } catch (e) {
          // Permission denied when accessing className from cross-origin iframe - ignore
          return;
        }
        if (classNameString != "item") {
          this.closeDropdown();
        }
      }
    } catch (e) {
      // Ignore permission errors from cross-origin iframes or restricted contexts
    }
  }

  constructor(
    myElement: ElementRef,
    private themeService: ThemeService
  ) {
    super();
    this.elementRef = myElement;
   }

  ngOnInit() {}

  isOpen(): boolean {
    return this.dropdownContent != null && this.dropdownContent.nativeElement.classList.contains("dd-open");
  }

  shouldBeRed(): boolean {
    return this.redText;
  }

  dropdownClick() {

    if (this.isOpen()) {
      this.closeDropdown();
    }
    else {
      this.openDropdown();
    }
  }

  openDropdown() {
    if (this.dropdownContent && this.dropdownContent.nativeElement) {
      let className = "dropdown-content dd-open";
      if (this.right) {
        className += " right";
      }
      this.dropdownContent.nativeElement.className = className;
      this.onOpen.emit();
    }
  }

  closeDropdown() {
    if (this.dropdownContent && this.dropdownContent.nativeElement) {
      let className = "dropdown-content dd-close";
      if (this.right) {
        className += " right";
      }
      this.dropdownContent.nativeElement.className = className;
    }
  }

  getSelection() {
    return this.selection;
  }

  getDownTriangleSrc(): string {
    return this.themeService.isDarkTheme() ? "./assets/images/white_down_triangle.png" : "./assets/images/black_down_triangle.png";
  }

  reset() {
    this.onReset.emit();
  }

}

export class CustomMap {
  key: string;
  value: string;
}

